export enum StudentNavigationDirection{
            First = 1,
            Next = 2,
            Previous = 3,
            Last = 4,
}